import _ from 'lodash';
import React from 'react';
import styled from 'styled-components';
import { useDebounce } from 'use-debounce';
import { useChangeAwareEffect } from 'use-change-aware-effect';
import useSearchUser from '../../../../services/user-search-service';
import CompaniesContext from './context';

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const Input = styled.input`
  height: 50px;
  padding: 15px 23px;
`;

const UsersContainer = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid ${props => props.theme.secondaryColorLight};
  border-top: none;
  border-radius: 4px;
  padding: 16px 8px;
`;

const Row = styled.div`
  border-radius: 4px;
  padding: 8px;

  &:hover {
    background-color: ${props => props.theme.secondaryColorLight};
    cursor: pointer;
  }
`;

const NoResult = styled.div`
  padding: 8px;
`;

export default function MemberSearchControl() {
  const [, search] = useSearchUser();
  const { state: { currentEditingCompany }, dispatch } = React.useContext(CompaniesContext);
  const [users, setUsers] = React.useState([]);
  const [value, setValue] = React.useState('');
  const [query] = useDebounce(value, 300);

  const handleOnChange = e => setValue(e.target.value);

  useChangeAwareEffect(({ did }) => {
    did.query.change && query && search('contributors', query).then(({ data }) => {
      const foundUsers = _.get(data, 'users', []);
      if (foundUsers) {
        const filteredUsers = foundUsers.filter(u => {
          const notExisting = _.every(currentEditingCompany.members, m => m.id !== u.profile_id);
          return notExisting && (!u.company_id || u.company_id === currentEditingCompany.id);
        });
        setUsers(filteredUsers);
      }
    });
  }, { query });

  const addMember = (e, user) => {
    e && e.preventDefault();

    dispatch({ type: 'addMember', payload: { id: user.profile_id, name: user.name, role: user.role } });
    setValue('');
  };

  return (
    <Container>
      <Input type="text" placeholder="Search for a team member" value={value} onChange={handleOnChange} />
      {query.length > 0 && (
        <UsersContainer>
          {users.map(user => (
            <Row key={user.id} onClick={e => addMember(e, user)}>
              {`${user.name} (${user.email})`}
            </Row>
          ))}
          {users.length === 0 && <NoResult>No Result</NoResult>}
        </UsersContainer>
      )}
    </Container>
  );
}
